<template>
  <div id="ly_goods">

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
      addText="添加商品" @addFn="addGoods" :addTexts="btnPreFn('travel_label', false) ? '标签配置' : ''" @addFns="addTag">
      <!-- 操作 -->
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="128px">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" @click="viewStock(row)">库存</el-button>
            <el-dropdown @command="handleCommand($event, row)" style="margin-left: 10px;">
              <el-button type="text">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="up" v-if="row.status === 2">上架商品</el-dropdown-item>
                <el-dropdown-item command="down" v-else>下架商品</el-dropdown-item>
                <el-dropdown-item command="edit">编辑商品</el-dropdown-item>
                <el-dropdown-item command="delete">删除商品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'name'">
          <el-tag v-if="row.status === 1" size="small" type="success">上架</el-tag>
          <el-tag v-else type="info" size="small">下架</el-tag>
          <span style="margin-left: 10px;">{{ row.name }}</span>
        </template>
        <template v-else-if="item.prop === 'city'">
          <span v-if="row.province && row.city">{{ `${row.province} / ${row.city}` }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'travelLineName'">
          <div class="ellipsis">
            去程：
            <template v-if="row.goLineList?.length > 0">
              <span v-for="item in row.goLineList" :key="item.id">
                <span>{{ item.startStationName }} - {{ item.endStationName }}</span>&nbsp;&nbsp;
              </span>
            </template>
            <span v-else>-</span>
          </div>
          <div class="ellipsis">
            返程：
            <template v-if="row.returnLineList?.length > 0">
              <span v-for="item in row.returnLineList" :key="item.id">
                <span>{{ item.startStationName }} - {{ item.endStationName }}</span>&nbsp;&nbsp;
              </span>
            </template>
            <span v-else>-</span>
          </div>
        </template>
        <template v-else-if="item.prop === 'reservationTime'">
          <div style="margin-right: 5px;">最早可预约：{{ row.advanceReservationTime == 0 ? '当天' : `${row.advanceReservationTime}天后` }}</div>
          <div class="ellipsis">最晚可预约：{{ `${row.reservationTime}天内` }}</div>
        </template>
        <template v-else-if="item.prop === 'price'">
          <span class="util-money">￥{{ $utils.getMinPrice(row) }}起</span>
        </template>
       
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] :
            "-" }}</span>
        </template>
      </template>
    </custom-table>

    <LabelDialog :labelVisible.sync="labelVisible" @refresh="getLabelList" />
  </div>
</template>

<script>
import { cityCodeJson } from "@/assets/js/city";
import LabelDialog from '../components/LabelDialog.vue';
export default {
  name: "ly_goods",
  components: {
    LabelDialog
  },
  data() {
    return {
      labelVisible: false,
      labelList: [],
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/travelGoods",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "goodsNo", name: "商品编号", value: "" },
          { type: "input", field: "name", name: "商品名称", value: "" },

          {
            type: "select", field: "labelId", name: "商品标签", value: "", options: [], filterable: true
          },
          {
            type: "cascader", field: "cityCode", name: "适用城市", value: "", option: cityCodeJson,
            props: {
              label: "name",
              value: "citycode",
              children: "districts",
            }
          },
          { type: "select", field: "status", name: "商品状态", option: [{ label: '上架', value: 1 }, { label: '下架', value: 2 }], value: "" },
        ],
      },
      // 表头
      columns: [
        { prop: "goodsNo", label: "商品编号", minWidth: 100 },
        { prop: "name", label: "商品名称", minWidth: 200 },
        { prop: "labelNames", label: "标签", minWidth: 200 },
        { prop: "city", label: "适用城市", minWidth: 150 },
        { prop: "travelLineName", label: "关联线路", minWidth: 250 },
        { prop: "reservationTime", label: "预约要求", width: 150 },
        { prop: "price", label: "商品价格（元）", width: 110 },
      ],
    };
  },
  computed: {
    
  },
  created() {
    this.getLabelList();
  },
  methods: {
    addTag() {
      this.labelVisible = true;
    },
    async getLabelList() {
      let url = "/api/v1/manage/travelLabel";
      let { code, data } = await this.$axios.get(url);
      if (code === 1) {
        let index = this.customOptions.search.findIndex(item => item.field === 'labelId');
        this.customOptions.search[index].option = data.map(item => ({ label: item.name, value: item.id }));
        this.$set(this.customOptions, 'search', [...this.customOptions.search]);
      }
    },
    // 创建商品
    addGoods() {
      this.$router.push({ path: '/ly_goodsCreate' });
    },
    // 库存
    viewStock(row) {
      this.$router.push({ path: '/ly_goodsInventory', query: { id: row.id } });
    },
    handleCommand(command, row) {
      if (command === 'edit') {
        this.$router.push({ path: '/ly_goodsEdit', query: { id: row.id } });
      } else if (command === 'delete') {
        this.$confirm('是否删除当前商品？', '删除商品', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let url = "/api/v1/manage/travelGoods";
          let { code } = await this.$axios.delete(url, {
            id: row.id
          })
          if (code === 1) {
            this.$message.success('删除成功');
            this.$refs.customTable.listFn();
          }
        }).catch(() => { });
      } else if (command === 'up') {
        this.$confirm('是否上架该旅游商品？', '上架商品', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let url = "/api/v1/manage/travelGoods/status";
          let { code } = await this.$axios.put(url, {
            id: row.id,
            status: 1
          })
          if (code === 1) {
            this.$message.success('上架成功');
            this.$refs.customTable.listFn();
          }
        })
      } else if (command === 'down') {
        this.$confirm('下架后该商品将无法继续下单，是否下架该商品？', '下架商品', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let url = "/api/v1/manage/travelGoods/status";
          let { code } = await this.$axios.put(url, {
            id: row.id,
            status: 2
          })
          if (code === 1) {
            this.$message.success('下架成功');
            this.$refs.customTable.listFn();
          }
        })
      }
    },
    
  },
};
</script>

<style lang="less" scoped>
#ly_goods {
  // 操作按钮样式
  .custom-action {
    display: flex;
    align-items: center;
    
    .el-button--text {
      padding: 0;
      color: #2B77FF;
      
      &:hover {
        color: #1a5fd9;
      }
    }
    
    .el-dropdown {
      .el-button--text {
        color: #2B77FF;
        
        &:hover {
          color: #1a5fd9;
        }
      }
    }
  }

  // 价格样式
  .util-money {
    font-weight: 600;
    color: #F56C6C;
  }

  // 省略号样式 - 使用深度选择器穿透 scoped
  ::v-deep .ellipsis {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.6;
    font-size: 13px;
    color: #606266;
  }
}
</style>
